import { IS_LOGGED_IN } from 'constants/app';

export default function getIsLoggedIn(): boolean {
  return JSON.parse(localStorage.getItem(IS_LOGGED_IN) ?? 'false');
}
